@if (dialogStep$ | async; as dialogStep) {
  <shared-modal-container
    contentStyleClass="h-lt-sm-100-dvh"
    [headline]="
      smartSearchType ? smartSearchTypeHeadlineMap.get(smartSearchType) : 'New smart search'
    "
    [isDialogPositionUp]="isDialogPositionUp$ | async"
    [maxWidth]="'31rem'"
    (closeModal)="closeForm()">
    <form class="step-wrapper bg-light w-100" [formGroup]="addSmartSearchForm">
      @switch (dialogStep) {
        @case (AddSmartSearchDialogStep.INITIAL) {
          <cp-add-smart-search-type-selection
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="typeSelection"
            (nextClicked)="nextStep()" />
        }
        @case (AddSmartSearchDialogStep.PROPERTY_SELECTION) {
          <cp-add-smart-search-property-selection
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="propertySelection"
            [headline]="
              addSmartSearchForm.value.typeSelection.type === SmartSearchType.SPEAK_TO_AN_EXPERT
                ? 'Which property or mortgage do you need help with?'
                : 'Create new search for property'
            "
            [propertyWithMortgageSelectItems]="propertyWithMortgageSelectItems$ | async"
            [isLoadingPlatformItems]="isLoadingPlatformItems$ | async"
            [isSkipPropertySelectPossible]="isSkipPropertySelectPossible$ | async"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) < AddSmartSearchDialogStep.PROPERTY_SELECTION
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.NEW_PROPERTY_MORTGAGE_PURPOSE_SELECTION) {
          <cp-add-smart-search-new-property-purchase-type-selection
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="newPropertyPurchaseTypeSelection"
            [showFirstTimeBuyerButton]="(hasClientResidentialProperty$ | async) === false"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) <
              AddSmartSearchDialogStep.NEW_PROPERTY_MORTGAGE_PURPOSE_SELECTION
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.NEW_PROPERTY_INVESTMENT_TYPE_SELECTION) {
          <cp-add-smart-search-new-property-investment-type-selection
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="newPropertyInvestmentTypeSelection"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) <
              AddSmartSearchDialogStep.NEW_PROPERTY_INVESTMENT_TYPE_SELECTION
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.NEW_PROPERTY_MAXIMUM_PRICE) {
          <cp-add-smart-search-new-property-maximum-price
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="newPropertyMaximumPrice"
            [ageInYears]="(clientUserData$ | async).age"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) < AddSmartSearchDialogStep.NEW_PROPERTY_MAXIMUM_PRICE
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.NEW_PROPERTY_MAXIMUM_PRICE_SPECIFY_SEARCH) {
          <cp-add-smart-search-specify-search
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="specifySearch"
            [isSaving]="isSaveInProgress$ | async"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) <
              AddSmartSearchDialogStep.NEW_PROPERTY_MAXIMUM_PRICE_SPECIFY_SEARCH
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.REMORTGAGE_BORROW_MORE) {
          <cp-add-smart-search-remortgage-borrow-more
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="remortgageBorrowMore"
            [currentPropertyMortgageData]="
              addSmartSearchForm.controls.propertySelection.controls.propertyMortgageSelectItem
                .value
            "
            [isBackButtonVisible]="
              (startingDialogStep$ | async) < AddSmartSearchDialogStep.REMORTGAGE_BORROW_MORE
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.REMORTGAGE_PAY_FASTER) {
          <cp-add-smart-search-remortgage-pay-mortgage-faster
            [currentPropertyMortgageData]="
              addSmartSearchForm.controls.propertySelection.controls.propertyMortgageSelectItem
                .value
            "
            [payMortgageFasterSaving]="payMortgageFasterSaving$ | async"
            [isLoadingPayMortgageFasterSaving]="isLoadingPayMortgageFasterSaving$ | async"
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="remortgagePayMortgageFaster"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) < AddSmartSearchDialogStep.REMORTGAGE_PAY_FASTER
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()"
            (calculatePayMortgageFasterSaving)="calculatePayMortgageFasterSaving($event)" />
        }
        @case (AddSmartSearchDialogStep.REMORTGAGE_BORROW_MORE_SPECIFY_SEARCH) {
          <cp-add-smart-search-specify-search
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="specifySearch"
            [isSaving]="isSaveInProgress$ | async"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) <
              AddSmartSearchDialogStep.REMORTGAGE_BORROW_MORE_SPECIFY_SEARCH
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.REMORTGAGE_PAY_FASTER_SPECIFY_SEARCH) {
          <cp-add-smart-search-specify-search
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="specifySearch"
            [isSaving]="isSaveInProgress$ | async"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) <
              AddSmartSearchDialogStep.REMORTGAGE_PAY_FASTER_SPECIFY_SEARCH
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
        @case (AddSmartSearchDialogStep.SPEAK_TO_AN_EXPERT) {
          <cp-add-smart-search-remortgage-speak-to-an-expert
            [@slideOnEnterAndLeave]="{
              value: true,
              params: isDirectionForward
                ? { enterTranslate: '100%', leaveTranslate: '-100%' }
                : { enterTranslate: '-100%', leaveTranslate: '100%' },
            }"
            formGroupName="remortgageSpeakToAnExpert"
            [clientUserData]="clientUserData$ | async"
            [isSaving]="isSaveInProgress$ | async"
            [isBackButtonVisible]="
              (startingDialogStep$ | async) < AddSmartSearchDialogStep.SPEAK_TO_AN_EXPERT
            "
            (nextClicked)="nextStep()"
            (backClicked)="previousStep()" />
        }
      }
    </form>
  </shared-modal-container>
}
